module.exports = __webpack_public_path__ + "img/bobbibrown_logo_header.ba564848.png";